import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.us';

export default {
  name: 'cleave',
  bind(component, binding) {
    const inputField = component.querySelector('input');
    inputField.cleave = new Cleave(inputField, binding.value);
  },
  update(component) {
    const event = new Event('input', { bubbles: true });
    setTimeout(() => {
      const input = component.querySelector('input');
      input.dispatchEvent(event);
    });
  },
  unbind(component) {
    const inputField = component.querySelector('input');
    inputField.cleave.destroy();
  },
};
